import React, { Component, PureComponent, Fragment } from 'react'
import { Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import DataTable from '~/datatable'
import { Map, List, fromJS } from 'immutable'
import { Link } from 'react-router-dom'
import TaskAdd from '~/task/views/add'
import TaskEdit from '~/task/views/edit'
import moment from 'moment'
import { fetchTaskTypes } from '~/taskType/actions'
import Helmet from 'react-helmet'

let statusMap = {
  pending: 'Odottaa',
  working: 'Työn alla',
  done: 'Valmis',
}

const columns = [
  {
    name: 'task_type',
    label: 'Aihe',
    sortable: true,
    render: (i, column, { editTask }) => {
      let id = i.get('id')
      let status = i.get('status')
      let deadline = moment(i.get('deadline'), 'YYYY-MM-DD HH:mm:ss.SSSZZ')

      let statusColor = 'default'

      if (status === 'working') statusColor = 'info'

      if (status === 'completed') statusColor = 'success'

      let late = moment().isAfter(deadline)

      if (late && status !== 'completed') statusColor = 'error'

      return (
        <Fragment>
          <span className={`status status--${statusColor}`} />
          <button className="button-plain" onClick={e => e.preventDefault() & editTask(id)}>
            {i.getIn(['data', '_task', 'icon']) ? <Icon name={i.getIn(['data', '_task', 'icon'])} /> : null}
            {i.getIn(['data', 'subject']) || i.getIn(['data', '_task', 'name']) || '(Tehtävän aihe puuttuu)'}
          </button>
        </Fragment>
      )
    },
  },
  {
    name: 'target',
    label: 'Kohde',
    render: i => {
      let targets = []
      targets.push(
        <Link
          to={`/project/${i.get('project_id')}/interview/${i.get('interview_id')}`}
          className="tags-item tags-item--blue"
          key={i.get('interview_id')}>
          {i.getIn(['interview', 'name'])}
        </Link>
      )

      return <div className="tags">{targets}</div>
    },
  },
  {
    name: 'user',
    label: 'Vastuuhenkilö',
    sortable: true,
    render: i => i.getIn(['user', 'name'], '(Ei asetettu)'),
  },
  {
    name: 'deadline',
    label: 'Määräaika',
    sortable: true,
    defaultSort: true,
    date: true,
  },
]

/*
filters
defaultFilters={{user_id: user.id}}
filterFields={filterFields}
 */

class ProjectTasks extends PureComponent {
  componentDidMount = () => {
    let { typesLoading, fetchTaskTypes } = this.props
    if (typesLoading) fetchTaskTypes()
  }

  render() {
    let { user, addTask, editTask, adding, editing, tasks, types, typesLoading, project } = this.props

    if (!project.get('id')) return null

    let editingTask = editing ? tasks.find(t => t.get('id') === editing) : false

    const filterFields = [
      {
        type: 'group',
        placeholder: 'Tehtävät',
        icon: 'check',
        fields: [
          {
            name: 'task_type_id',
            type: 'checkboxes',
            label: 'Tehtävätyyppi',
            options: types
              .map(t => ({ value: t.get('id'), label: t.get('name'), icon: t.getIn(['data', 'icon'], 'check') }))
              .toArray(),
          },
        ],
      },
      {
        name: 'deadline',
        type: 'dates',
      },
    ]

    return (
      <Fragment>
        <DataTable
          id={`tasks-${project.get('id')}`}
          entity="task"
          filters
          sortDir="desc"
          title={`Projekti ${project.get('name')} tehtävät`}
          actions={[{ text: 'Luo tehtävä', icon: 'plus', action: () => addTask() }]}
          filterFields={filterFields}
          defaultFilters={{ project_id: [project.get('id')] }}
          context={{ editTask: id => editTask(id) }}
          disableLocalFilters
          columns={columns}
        />
        {editingTask ? (
          <TaskEdit task={editingTask} onClose={() => editTask(false)} />
        ) : adding ? (
          <TaskAdd onClose={() => addTask(false)} project={project} />
        ) : null}
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    project: state.activeProject,
    types: state.taskTypes,
    typesLoading: state.taskTypesLoading,
    user: state.authUser || {},
    adding: state.rootTaskCreating,
    editing: state.rootTaskEditing,
    tasks: state.dataTable.getIn(['tasks', 'items'], List()),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addTask: (add = true) => dispatch({ type: 'ROOT_CREATE_TASK', add }),
    editTask: id => dispatch({ type: 'ROOT_EDIT_TASK', id }),
    fetchTaskTypes: () => dispatch(fetchTaskTypes()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTasks)
